/**
 * Build-time feature flags (Vite `import.meta.env.VITE_*`).
 *
 * Keep these as simple string comparisons so they can be toggled purely from the
 * environment with no code change, mirroring the CMS flag in `roleMenus.config.tsx`.
 */

/**
 * Gates public user self-registration: the `/signup` route and every entry point
 * that links to it (navbar button, login-page link, landing-page CTAs).
 *
 * Disabled by default — users are created only through the backoffice
 * (`/admin/users`) / company-admin flows. Set `VITE_FEATURE_SIGNUP=true` to
 * restore public registration; no code change required.
 */
export const isSignupEnabled = import.meta.env.VITE_FEATURE_SIGNUP === 'true';

/**
 * Gates the AI prompt-templates admin screen (`/admin/prompt-templates`) and its menu entry.
 *
 * Enabled by default. Set VITE_FEATURE_PROMPT_TEMPLATES=false to hide the screen while keeping
 * the backend endpoints ADMIN-only regardless of this flag.
 */
export const isPromptTemplatesEnabled =
  import.meta.env.VITE_FEATURE_PROMPT_TEMPLATES !== 'false';
